import React, { MouseEventHandler } from 'react';
import SVG from 'react-inlinesvg';
import ArrowIcon from 'assets/icon/arrow.svg';

interface Props {
  direction: 'up' | 'down' | 'left' | 'right';
  onClick: MouseEventHandler<HTMLButtonElement>;
  margin?: string;
}

const ArrowButton = ({ direction, onClick, margin }: Props) => {
  let rotateDegrees: number;
  switch (direction) {
    case 'up':
      rotateDegrees = 0;
      break;
    case 'down':
      rotateDegrees = 180;
      break;
    case 'left':
      rotateDegrees = -90;
      break;
    case 'right':
      rotateDegrees = 90;
      break;
  }

  return (
    <button
      style={{
        margin: margin || 0,
        padding: 0,
        background: 'none',
        border: 'none',
        height: '15px',
        width: '15px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onClick}
    >
      <SVG style={{ transform: `rotate(${rotateDegrees}deg)` }} src={ArrowIcon} />
    </button>
  );
};

export default ArrowButton;
